export default "__VITE_ASSET__DIrO5EfI__"